// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/images/yg-background.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".daily-chat-layout[data-v-da2f0406]{display:flex;flex-direction:column;min-height:100vh;color:#fff;background:#ff412c url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat center center;background-size:cover;font-family:\"Graphik\",\"Rawline\",\"Arial\",sans-serif}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
